export default __webpack_public_path__ + "static/seoImage-68babcc1191c51b28a521d8baccc7cae.webp";